// extracted by mini-css-extract-plugin
module.exports = {"list":"_6bf55ce5dc--list--qoYYB"};